import * as T from 'src/store/types'
import Vue from 'vue'

export default {
  [T.SET_ITOKEN_VOUCHER_DATA](state, payload = {}) {
    Vue.set(state.voucherData, 'data', payload)
  },
  [T.SET_ITOKEN_VOUCHER_LIST](state, payload = false) {
    Vue.set(
      state.voucherList,
      'list',
      payload
        ? payload.list
        : {
            data: [],
            total: 0,
          }
    )
  },
  [T.SET_ITOKEN_CAMPAIGN_LIST](state, payload) {
    Vue.set(state.campaignList, 'list', payload.list)
  },
  [T.SET_ITOKEN_CAMPAIGN_DATA](state, payload) {
    Vue.set(state.campaign, 'data', payload.data)
  },
  [T.SET_ITOKEN_REDEMPTION_LIST](state, payload) {
    Vue.set(state.redemptionList, 'list', payload.list)
  },
  [T.SET_ITOKEN_REDEMPTION_DATA](state, payload) {
    Vue.set(state.redemption, 'data', payload.data)
  },
  [T.SET_ITOKEN_CAMPAIGN_LIST](state, payload) {
    Vue.set(state.campaignList, 'list', payload.list)
  },
  [T.SET_ITOKEN_ACCUMULATE_CALCULATION_LIST](state, payload) {
    Vue.set(state.accumulateCalculationList, 'list', payload.list)
  },
}
